var _mask, _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProgress9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_381_489",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0C12.1063 2.5117e-08 14.1588 0.665059 15.8648 1.90033C17.5708 3.13561 18.8432 4.87802 19.5005 6.87908C20.1579 8.88014 20.1666 11.0377 19.5254 13.044C18.8843 15.0503 17.626 16.8029 15.9301 18.052C14.2341 19.301 12.1871 19.9826 10.0809 19.9997C7.97467 20.0167 5.91687 19.3683 4.20093 18.1468C2.48499 16.9254 1.19854 15.1933 0.52503 13.1976C-0.148479 11.202 -0.174651 9.04458 0.450247 7.03315L10 10L10 0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C12.1063 2.5117e-08 14.1588 0.665059 15.8648 1.90033C17.5708 3.13561 18.8432 4.87802 19.5005 6.87908C20.1579 8.88014 20.1666 11.0377 19.5254 13.044C18.8843 15.0503 17.626 16.8029 15.9301 18.052C14.2341 19.301 12.1871 19.9826 10.0809 19.9997C7.97467 20.0167 5.91687 19.3683 4.20093 18.1468C2.48499 16.9254 1.19854 15.1933 0.52503 13.1976C-0.148479 11.202 -0.174651 9.04458 0.450247 7.03315L10 10L10 0Z",
    fill: "#09702B",
    stroke: "#09702B",
    strokeWidth: 4,
    mask: "url(#path-1-inside-1_381_489)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9,
    transform: "rotate(-90 10 10)",
    stroke: "#09702B",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress9);
export default __webpack_public_path__ + "static/media/progress9.fdc96453d9ef0ff472ac800d5d758fea.svg";
export { ForwardRef as ReactComponent };